import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {SubSink} from "subsink";
import {ActionWithCorrelationAttributes, CorrelationObserverService} from "@kion/ngrx-helper";
import {ActivatedRoute} from "@angular/router";
import {CmsPagesFacade} from "@kion/data-access/data-access-cms-pages";
import {ToastService} from "@kion/ui";
import {filter, map, tap} from "rxjs/operators";
// tslint:disable-next-line:nx-enforce-module-boundaries
import {IPartner} from "../../../../../../shared/data-access/data-access-cms-pages/src/lib/+state/cmsPages.reducer";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from 'ngx-markdown';
import { CmsConfig } from '../../config/cms.config';

@Component({
  selector: 'kion-cms-network-partner-privacy-policy',
  templateUrl: './network-partner-privacy-policy.component.html',
  styleUrls: ['./network-partner-privacy-policy.component.scss']
})
export class NetworkPartnerPrivacyPolicyComponent implements OnInit {

  data$: Observable<SafeHtml>;
  subSink: SubSink;
  project: string;

  private action: ActionWithCorrelationAttributes;
  private nwpId: string;

  constructor(private route: ActivatedRoute,
              private cmsPageFacade: CmsPagesFacade,
              private correlationObserverService: CorrelationObserverService,
              private toastService: ToastService,
              private sanitizer: DomSanitizer,
              private markdownService: MarkdownService,
              private cmsConfig: CmsConfig) { }

  ngOnInit(): void {
    this.project = this.cmsConfig.project;
    this.subSink = new SubSink();
    this.subSink.sink =this.route.paramMap.pipe(
      map(params => params.get('nwpId'))
    ).subscribe(nwpId => {
      this.action = this.cmsPageFacade.loadNetworkPartnerPrivacyPolicyContent(nwpId)
      this.nwpId = nwpId
    })

    this.subSink.sink = this.correlationObserverService.subscribeToAction(
      this.action,
      () => {
        this.data$ = this.cmsPageFacade.partnerLegals$.pipe(
          filter((partner: { [id: number]: IPartner }) => partner[this.nwpId] !== undefined),
          map((partner: { [id: number]: IPartner }) => partner[this.nwpId].privacyPolicy),
          map(
            data =>  this.sanitizer.bypassSecurityTrustHtml(this.markdownService.compile(data))
          )
        )
      },
      () => {
        //TODO: translate (local)
        this.toastService.show(
          {
            text: 'could not load page',
            type: 'error'
          }
        );
      }
    )
  }

}
